import { useMemo } from 'react';

function useNeuronPlatformList(storeList: Store.Store[]) {
  return useMemo(() => {
    return Object.keys(
      storeList.reduce<Partial<Record<General.PlatformUpperCase, true>>>((res, cur) => {
        res[cur.externalType] = true;

        return res;
      }, {}),
    );
  }, [storeList]);
}

export default useNeuronPlatformList;
